// extracted by mini-css-extract-plugin
module.exports = {"phoneBookList":"contact_phoneBookList__24FwO","contact":"contact_contact__1USSa","button":"contact_button__7PwTq"};